/* =========================================================================
   Atelier Diamante — Header v2 JS  (ad-header.js)
   Scroll behaviour, mega-menu, search overlay, mobile drawer.
   ========================================================================= */

(function () {
  'use strict';

  var header    = document.getElementById('ad-header');
  if (!header) return;

  var overlay   = document.getElementById('ad-mobile-overlay');
  var drawer    = document.getElementById('ad-mobile-drawer');
  var hamburger = document.getElementById('ad-hamburger');
  var closeBtns = [document.getElementById('ad-drawer-close')];

  /* ── Dynamic header height CSS var ─────────────────────────────────────── */

  function setHeaderHeight () {
    var announce = document.getElementById('ad-announce');
    var total    = header.offsetHeight + (announce ? announce.offsetHeight : 0);
    document.documentElement.style.setProperty('--ad-header-height', total + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  /* ── Scroll: opaque / hide / show ──────────────────────────────────────── */

  var lastY          = window.scrollY;
  var ticking        = false;
  var SCROLL_DELTA   = 10;
  var OPAQUE_AT      = 50;

  function onScroll () {
    var y    = window.scrollY;
    var diff = y - lastY;

    /* Opaque switch */
    header.classList.toggle('is-scrolled', y > OPAQUE_AT);

    /* Hide on scroll-down, show on scroll-up */
    if (diff > SCROLL_DELTA && y > 140) {
      header.classList.add('is-hidden');
      closeAllMega();
    } else if (diff < -SCROLL_DELTA) {
      header.classList.remove('is-hidden');
    }

    lastY   = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });

  /* ══════════════════════════════════════════════════════════════════════════
     MEGA MENU
     ══════════════════════════════════════════════════════════════════════ */

  var megaPanels = {};
  var activeNav  = null;
  var closeTimer = null;

  document.querySelectorAll('.ad-header__nav-item[data-mega]').forEach(function (item) {
    var key     = item.dataset.mega;
    var panel   = document.getElementById('ad-mega-' + key);
    var trigger = item.querySelector('.ad-header__nav-link');
    if (!panel || !trigger) return;

    megaPanels[key] = { item: item, panel: panel, trigger: trigger };

    /* Hover open */
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openMega(key);
    });

    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () { closeMega(key); }, 120);
    });

    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () { closeMega(key); }, 120);
    });

    /* Click toggle (for touch) */
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-open')) {
        closeMega(key);
      } else {
        openMega(key);
      }
    });

    /* Keyboard: Enter/Space */
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          closeMega(key);
        } else {
          openMega(key);
          var first = panel.querySelector('a');
          if (first) first.focus();
        }
      }
    });

    /* Escape from inside panel */
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMega(key); trigger.focus(); }
    });
  });

  function openMega (key) {
    /* Close others first */
    Object.keys(megaPanels).forEach(function (k) { if (k !== key) closeMega(k); });

    var m = megaPanels[key];
    if (!m) return;
    m.panel.classList.add('is-open');
    m.panel.setAttribute('aria-hidden', 'false');
    m.item.classList.add('is-active');
    m.trigger.setAttribute('aria-expanded', 'true');
    activeNav = key;
  }

  function closeMega (key) {
    var m = megaPanels[key];
    if (!m) return;
    m.panel.classList.remove('is-open');
    m.panel.setAttribute('aria-hidden', 'true');
    m.item.classList.remove('is-active');
    m.trigger.setAttribute('aria-expanded', 'false');
    if (activeNav === key) activeNav = null;
  }

  function closeAllMega () {
    Object.keys(megaPanels).forEach(closeMega);
  }

  /* Close mega on outside click */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ad-header__nav-item[data-mega]') && !e.target.closest('.ad-mega')) {
      closeAllMega();
    }
  });

  /* ══════════════════════════════════════════════════════════════════════════
     SEARCH OVERLAY
     ══════════════════════════════════════════════════════════════════════ */

  var searchToggle  = document.getElementById('ad-search-toggle');
  var searchOverlay = document.getElementById('ad-search-overlay');
  var searchClose   = document.getElementById('ad-search-close');
  var searchInput   = searchOverlay ? searchOverlay.querySelector('input') : null;

  function openSearch () {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    closeAllMega();
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 150);
  }

  function closeSearch () {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }

  if (searchToggle) searchToggle.addEventListener('click', function () {
    if (searchOverlay.classList.contains('is-open')) closeSearch(); else openSearch();
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* ══════════════════════════════════════════════════════════════════════════
     MOBILE DRAWER
     ══════════════════════════════════════════════════════════════════════ */

  function openDrawer () {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    var closeBtn = document.getElementById('ad-drawer-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer () {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    if (hamburger) hamburger.focus();
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (overlay)   overlay.addEventListener('click', closeDrawer);

  closeBtns.forEach(function (btn) {
    if (btn) btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      if (searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
    }
  });

  /* ── Mobile submenu toggles ────────────────────────────────────────────── */

  document.querySelectorAll('.ad-mobile-nav__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.classList.toggle('is-open', !expanded);
    });
  });

  /* ══════════════════════════════════════════════════════════════════════════
     CART
     ══════════════════════════════════════════════════════════════════════ */

  var cartBtn   = document.getElementById('ad-cart-btn');
  var cartBadge = document.getElementById('ad-cart-badge');

  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('ad:cart-opened', { bubbles: true }));
    });
  }

  function refreshCartCount () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (data) {
      var count = data.item_count || 0;
      if (cartBadge) {
        cartBadge.textContent   = count;
        cartBadge.dataset.count = count;
        cartBadge.setAttribute('aria-label', count + ' items in cart');
      }
    }).catch(function () {});
  }

  refreshCartCount();
  document.addEventListener('ad:cart-updated', refreshCartCount);
  document.addEventListener('cart:refresh',    refreshCartCount);

})();
